import { ImageSlider, ImageSliderSlide } from '@definitions/types/storyblokTypes'

import { createImageSliderSlide } from '../../../../atoms/StoryblokImageSliderSlide/__mocks__/imageSliderSlide'

/**
 * Creates a mock ImageSlider
 * @param overrides - Partial fields to override defaults
 * @returns Complete ImageSlider mock
 */
export function createImageSlider(
  overrides: Partial<ImageSlider> = {}
): ImageSlider {
  return {
    _uid: 'c3a0393d-f0d2-48f4-9c34-604f59f21e16',
    slides: [
      createImageSliderSlide({
        _uid: '74d9214c-e358-45ba-8b36-e8aa82611ca5',
        Image: {
          ...createImageSliderSlide().Image,
          id: 13912736,
          alt: 'dummy_slider_769x466_04',
          title: 'dummy_slider_769x466_04',
          filename:
            'https://a.storyblok.com/f/235453/769x466/64824f0b67/dummy_slider_769x466_04.jpeg',
          src: 'https://a.storyblok.com/f/235453/769x466/64824f0b67/dummy_slider_769x466_04.jpeg',
        },
      }),
      createImageSliderSlide({
        _uid: 'bff10506-f6ca-4d5d-b32c-8d83e727c80a',
        Image: {
          ...createImageSliderSlide().Image,
          id: 13912735,
          alt: 'dummy_slider_769x466_06',
          title: 'dummy_slider_769x466_06',
          filename:
            'https://a.storyblok.com/f/235453/769x466/f2c3e78d93/dummy_slider_769x466_06.jpeg',
          src: 'https://a.storyblok.com/f/235453/769x466/f2c3e78d93/dummy_slider_769x466_06.jpeg',
        },
      }),
      createImageSliderSlide({
        _uid: '8eaa9331-3393-455a-86df-046f3336ff51',
        Image: {
          ...createImageSliderSlide().Image,
          id: 13912734,
          alt: 'dummy_slider_769x466_05',
          title: 'dummy_slider_769x466_05',
          filename:
            'https://a.storyblok.com/f/235453/769x466/f6b5705fc8/dummy_slider_769x466_05.jpeg',
          src: 'https://a.storyblok.com/f/235453/769x466/f6b5705fc8/dummy_slider_769x466_05.jpeg',
        },
      }),
      createImageSliderSlide({
        _uid: 'f8467eb3-223b-473e-953a-9745adde1726',
        Image: {
          ...createImageSliderSlide().Image,
          id: 13912326,
          alt: 'dummy_slider_769x466_01',
          title: 'dummy_slider_769x466_01',
          filename:
            'https://a.storyblok.com/f/235453/769x466/dc9bf8d3e3/dummy_slider_769x466_01.jpeg',
          src: 'https://a.storyblok.com/f/235453/769x466/dc9bf8d3e3/dummy_slider_769x466_01.jpeg',
        },
      }),
    ],
    subline: 'Subline des Slider',
    headline: 'Image Slider',
    component: 'image-slider',
    _editable:
      '<!--#storyblok#{"name": "image-slider", "space": "235453", "uid": "c3a0393d-f0d2-48f4-9c34-604f59f21e16", "id": "424177377"}-->',
    ...overrides,
  }
}
